import React from 'react';
import { EyeIcon, GraduationCapIcon, SparklesIcon, SchoolIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
const icons = [EyeIcon, SparklesIcon, SchoolIcon, GraduationCapIcon];
const tints = ['#F6DDD8', '#DCEFE6', '#D9EAF8', '#EADCF5'];
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-45" data-mp="1tbv90ai1jxg8">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="237py9ogrsqrz">
        <SectionHeading id="audience-heading" title={<>
              Created for Educators Who Want to <Accent data-id="element-48" data-mp="2gybhjea4z2qe">Teach More Efficiently</Accent>
            </>} data-id="element-47" data-mp="236na3oau12fr" />

        <ul className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4" role="list" data-id="element-49" data-mp="2cy1f2bljyuga">
          {audience.map((item, index) => {
          const Icon = icons[index];
          return <li key={item} className="flex flex-col items-center rounded-[20px] bg-white px-4 py-7 text-center" data-id="element-50" data-mp="2lziqvhrxg9z6" data-mpi={index}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full" style={{
              backgroundColor: tints[index]
            }} data-id="element-51" data-mp="1sd5fmkreuk6m">
                  <Icon className="h-5 w-5 text-brand-charcoal" strokeWidth={1.5} aria-hidden="true" data-id="element-52" data-mp="228z0crfa9jzh" />
                </span>
                <span className="mt-4 font-body text-[12px] font-bold uppercase leading-snug tracking-[0.1em] text-brand-charcoal sm:text-[13px]" data-id="element-53" data-mp="269921rw1lo8j">
                  {item}
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-54" data-mp="2kzztgytq2lb4">
          Whether you’re organizing your first training program or improving an existing one, this system gives you a
          structured foundation to build on.
        </p>
      </div>
    </section>;
}